import React from "react";
import { AccordionDetails, AccordionDetailsProps, SxProps, Theme } from "@mui/material";

export type WcAccordionDetailsProps = AccordionDetailsProps & {
  
  sx?: SxProps<Theme>;
 
}

export const WcAccordionDetails = (props: WcAccordionDetailsProps) => (
  <AccordionDetails sx={props.sx} {...props} />
);

export default WcAccordionDetails;
